import React from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import ResolvePopup from 'components/ResolvePopup';

import './SegmentedToggle.styles.scss';

type SegmentedToggleValue = string | number | boolean;

type SegmentedToggleOption = {
  label: React.ReactNode;
  value: SegmentedToggleValue;
  disabled?: boolean;
  tooltip?: React.ReactNode;
};

type SegmentedToggleProps = {
  className?: string;
  options: SegmentedToggleOption[];
  selectedValue: SegmentedToggleValue;
  variant?: 'default' | 'pill';
  onChange: (value: SegmentedToggleValue) => void;
};

const SegmentedToggle: React.FC<SegmentedToggleProps> = (props) => {
  const {
    className,
    options,
    selectedValue,
    variant = 'pill',
    onChange,
  } = props;

  const classes = classNames(
    'segmented-toggle',
    `segmented-toggle--${variant}`,
    className,
  );

  return (
    <div className={classes}>
      {options.map(({ label, value, disabled, tooltip }) => {
        const button = (
          <Button
            disabled={disabled}
            className={classNames({
              selected: selectedValue === value,
            })}
            onClick={() => onChange(value)}
          >
            {label}
          </Button>
        );

        // A disabled button doesn't emit mouse events, so the popup has to wrap it.
        return tooltip ? (
          <ResolvePopup
            key={String(value)}
            onHover
            popupContent={tooltip}
            className="segmented-toggle__popup"
          >
            {button}
          </ResolvePopup>
        ) : (
          <React.Fragment key={String(value)}>{button}</React.Fragment>
        );
      })}
    </div>
  );
};

export default SegmentedToggle;
